import {Card, Tabs, Avatar, Tag, Button, List, Divider, Pagination, Menu} from "antd";
import {CandidateList} from "@/pages/account/profile/sections/CandidateList";
import {ProfileSettings} from "@/pages/account/profile/sections/ProfileSettings/ProfileSettings";
import {CompanyApplications} from "@/pages/account/profile/sections/CompanyApplications";
import {ProfileCard} from "@/pages/account/profile/sections/ProfileCard";
import {SearchBar} from "@/pages/account/profile/components/SearchBar";
import {profile} from "../createApplyLists/profile";
import {EmptyProfileCard} from "@/pages/account/createApplyLists/components/EmptyProfileCard";
import {useState} from "react";
import {MenuOutlined} from "@ant-design/icons";
import ProfileCardMB from "@/pages/account/profile/sections/ProfileSettings/ProfileSettingsMB";

const {TabPane} = Tabs;

export const ProfileIndex = () => {
    const [active, setActive] = useState(true);
    const [selectedTab, setSelectedTab] = useState("1"); // Quản lý tab trên mobile

    const candidates = [
        {
            id: 1,
            avatar: "/img/logo.jpg",
            name: "Nguyễn Văn A",
            job: "Frontend Developer",
            location: "Hà Nội",
            phone: "123456789",
            email: "abc@fpt.edu.vn",
        },
        {
            id: 2,
            avatar: "/img/logo.jpg",
            name: "Nguyễn Văn B",
            job: "Backend Developer",
            location: "Hồ Chí Minh",
            phone: "123456789",
            email: "bcd@gmail.com",
        }
    ];

    const articles = [
        {
            title: "Công ty TNHH Tinviet Software",
            image: "/img/user_null.png",
            tags: ["3 người theo dõi", "Lâm Đồng", "FrontEnd developer"],
            description: "Là một doanh nghiệp hoạt động trong lĩnh vực chuyên biệt...",
            link: "https://ant.design",
            location: "Lâm Đồng",
            date: "2025-02-20 15:03",
        },
        {
            title: "Công ty TNHH Hoàng Gia",
            image: "/img/user_null.png",
            tags: ["3 người theo dõi", "Lâm Đồng", "FrontEnd developer"],
            description: "Là một doanh nghiệp hoạt động trong lĩnh vực chuyên biệt...",
            link: "https://ant.design",
            location: "Lâm Đồng",
            date: "2025-02-20 13:03",
        }
    ];

    const handleSearch = (query) => {
        console.log(query);
    };

    return (
        <div className="flex flex-col lg:flex-row gap-6 p-6 bg-gray-100 min-h-screen">
            {/* Sidebar (Chỉ hiển thị trên PC) */}
            <div className="w-1/4 hidden lg:block">
                {active ? <ProfileCard profile={profile}/> : <EmptyProfileCard/>}
            </div>

            {/* Main Content */}
            <div className="flex-1 hidden lg:block">
                <Tabs rootClassName="bg-white p-4 rounded-lg shadow-md" defaultActiveKey="1">
                    <TabPane tab="Danh sách công ty đã ứng tuyển" key="1">
                        <SearchBar onSearch={handleSearch}/>
                        <CompanyApplications articles={articles}/>
                    </TabPane>
                    <TabPane tab="Danh sách hồ sơ" key="2">
                        <SearchBar onSearch={handleSearch}/>
                        <CandidateList candidates={candidates}/>
                    </TabPane>
                    <TabPane tab="Chỉnh sửa thông tin" key="3">
                        <ProfileSettings/>
                    </TabPane>
                </Tabs>
            </div>

            {/* Mobile View */}
            <div className="lg:hidden w-full">
                {/* Menu cho Mobile */}
                <Menu
                    mode="horizontal"
                    selectedKeys={[selectedTab]}
                    onClick={(e) => setSelectedTab(e.key)}
                    className="bg-white shadow-md rounded-lg mb-4"
                >
                    <Menu.Item key="1" icon={<MenuOutlined/>}>
                        Hồ sơ hiện tại
                    </Menu.Item>
                    <Menu.Item key="2" icon={<MenuOutlined/>}>
                        Công ty đã ứng tuyển
                    </Menu.Item>
                    <Menu.Item key="3" icon={<MenuOutlined/>}>
                        Danh sách hồ sơ
                    </Menu.Item>
                    <Menu.Item key="4" icon={<MenuOutlined/>}>
                        Chỉnh sửa thông tin
                    </Menu.Item>
                </Menu>

                {/* Hiển thị nội dung tương ứng */}
                <div className="bg-white p-4 rounded-lg shadow-md">
                    {selectedTab === "1" && (
                        <ProfileCardMB profile={profile}/>
                    )}
                    {selectedTab === "2" && (
                        <>
                            <SearchBar onSearch={handleSearch}/>
                            <CompanyApplications articles={articles}/>
                        </>
                    )}
                    {selectedTab === "3" && (
                        <>
                            <SearchBar onSearch={handleSearch}/>
                            <CandidateList candidates={candidates}/>
                        </>
                    )}
                    {selectedTab === "4" && <ProfileSettings/>}
                </div>
            </div>
        </div>
    );
};
